// Shared styles for SDM tables
// Based on BusinessLocationsTable.js style

export const sdmTableStyles = {
  // Container wrapper
  tableWrapper: {
    marginBottom: "20px"
  },

  // Header section with title and optional add button
  headerSection: {
    marginBottom: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },

  // Section title
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#111827",
    letterSpacing: "-0.01em"
  },

  // TableContainer styles
  tableContainer: {
    border: "1px solid #E2E8F0",
    borderRadius: "8px",
    overflow: "hidden",
    overflowX: "auto"
  },

  // Table size
  tableSize: "small",

  // Header row styles
  headerRow: {
    backgroundColor: "#F8FAFC"
  },

  // Header cell base styles
  headerCell: {
    fontWeight: 600,
    fontSize: "12px",
    textTransform: "uppercase",
    color: "#64748B",
    borderBottom: "1px solid #E2E8F0",
    py: 1.5
  },

  // Data row styles
  dataRow: {
    "&:hover": { backgroundColor: "#F9FAFB" },
    "& td": { borderBottom: "1px solid #F1F5F9" }
  },

  // Cell padding for data cells
  dataCell: {
    p: 1
  },

  // TextField styles
  textField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      fontSize: "13px",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#CBD5E1" },
      "&.Mui-focused fieldset": { borderColor: "#2960EE" }
    },
    "& .MuiOutlinedInput-input": { padding: "8px 10px" }
  },

  // TextField styles with multiline support
  textFieldMultiline: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      fontSize: "13px",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#CBD5E1" },
      "&.Mui-focused fieldset": { borderColor: "#2960EE" }
    }
  },

  // Number input styles (hide spinners)
  numberField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      fontSize: "13px",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#CBD5E1" },
      "&.Mui-focused fieldset": { borderColor: "#2960EE" }
    },
    "& .MuiOutlinedInput-input": { padding: "8px 10px" },
    "& input[type=number]": {
      MozAppearance: "textfield"
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0
    }
  },

  // Select field styles
  selectField: {
    fontSize: "13px",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#E2E8F0" },
    "&:hover fieldset": { borderColor: "#CBD5E1" },
    "&.Mui-focused fieldset": { borderColor: "#2960EE" }
  },

  // Delete button styles
  deleteButton: {
    color: "#94A3B8",
    "&:hover": { color: "#EF4444", backgroundColor: "#FEF2F2" }
  },

  // Add row button (inside table, full width)
  addRowButton: {
    textTransform: "none",
    color: "#2960EE",
    fontSize: "13px",
    fontWeight: 500,
    py: 1,
    borderRadius: 0,
    backgroundColor: "transparent",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#F8FAFC",
      color: "#1e4ec4"
    }
  },

  // Empty row cell
  emptyCell: {
    borderBottom: "1px solid #E2E8F0",
    width: 50
  },

  // Empty state row
  emptyStateRow: {
    py: 3,
    color: "#94A3B8",
    textAlign: "center"
  },

  // Highlighted row (like total row in LimitDynamicsTable)
  highlightedRow: {
    backgroundColor: "#EFF6FF"
  },

  // Cell with add row button (no padding)
  addRowCell: {
    padding: "0 !important"
  }
};

// Helper function to get header cell with minWidth
export const getHeaderCellStyle = (minWidth) => ({
  ...sdmTableStyles.headerCell,
  minWidth
});

// Helper function to merge base styles with additional styles
export const mergeStyles = (baseStyle, additionalStyle = {}) => ({
  ...baseStyle,
  ...additionalStyle
});
